/* ALERT COLORS */
export const alertColors = {
    success: {
        background: '#F4F8F4',
        icon: '#367C2B',
        border: '#99BD93'
    },
    error: {
        background: '#FDF6F6',
        icon: '#C21020',
        border: '#DD737E'
    },
    warning: {
        background: '#FEF6EA',
        icon: '#F99700',
        border: '#FFBB52'
    },
    info: {
        background: '#F3F7FB',
        icon: '#005DB1',
        border: '#7AABD6'
    },
    default: {
        background: '#F3F7FB',
        icon: '#005DB1',
        border: '#7AABD6'
    }
} as const;

// build types from object
export type FuelAlertTypeKey = keyof typeof alertColors;
export type FuelAlertColorKey = keyof typeof alertColors[FuelAlertTypeKey];
export type FuelAlertColorValue = typeof alertColors[FuelAlertTypeKey][FuelAlertColorKey];

export const getAlertColor = (
    alertType?: FuelAlertTypeKey,
    alertShade?: FuelAlertColorKey
): FuelAlertColorValue => {
    if (!alertType || !alertShade) {
        return alertColors.info.background;
    }

    if (!(alertType in alertColors) && !(alertShade in alertColors[alertType])) {
        return alertColors.info.background;
    }

    return alertColors[alertType][alertShade];
};
